import React, { Component } from "react";
import { BASE_URL } from "../common/common";

const API_URL = BASE_URL;
const MAX_IMAGE_SIZE = 3 * 1024 * 1024; // 3 MB

const imgUrl = (path) => {
  console.log("Path = ", path);
  if (!path) return null;
  if (path.startsWith("http")) return `${path}?ngrok-skip-browser-warning=true`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}?ngrok-skip-browser-warning=true`;
};

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "banner",

      // Banner
      bannerView: "list",
      bannerList: [],
      bannerListLoading: false,
      bannerTitle: "Portfolio",
      bannerImagePreview: null,
      bannerFile: null,
      bannerSaving: false,
      editingBanner: null,

      // Portfolio
      portfolioView: "list",
      portfolioList: [],
      portfolioListLoading: false,
      editingPortfolio: null,

      // Event types from API
      eventTypes: [],
      eventTypesLoading: false,

      portfolioForm: {
        name: "",
        eventTypeId: "",
        images: [],
        saving: false,
      },

      successMessage: "",
      errorMessage: "",
    };
  }

  componentDidMount() {
    this.fetchBannerList();
    this.fetchPortfolioList();
    this.fetchEventTypes();
  }

  showSuccess = (msg) => {
    this.setState({ successMessage: msg, errorMessage: "" });
    setTimeout(() => this.setState({ successMessage: "" }), 3000);
  };

  showError = (msg) => {
    this.setState({ errorMessage: msg, successMessage: "" });
    setTimeout(() => this.setState({ errorMessage: "" }), 4000);
  };

  // ════════════════════════════════
  //  BANNER
  // ════════════════════════════════

  fetchBannerList = async () => {
    this.setState({ bannerListLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/banners/getBanners`, {
        method: "GET",
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      const json = await res.json();
      if (json.status) {
        const filtered = json.data.filter(
          (b) => b.Page_Name?.toLowerCase() === "portfolio",
        );
        this.setState({ bannerList: filtered, bannerListLoading: false });
      } else {
        this.setState({ bannerListLoading: false });
        this.showError("Failed to load banners.");
      }
    } catch (err) {
      this.setState({ bannerListLoading: false });
      this.showError("Cannot connect to API server.");
    }
  };

  openBannerForm = () => {
    this.setState({
      bannerView: "form",
      editingBanner: null,
      bannerTitle: "Portfolio",
      bannerImagePreview: null,
      bannerFile: null,
    });
  };

  openEditBanner = (banner) => {
    this.setState({
      bannerView: "form",
      editingBanner: banner,
      bannerTitle: banner.Page_Name || "Portfolio",
      bannerImagePreview: null,
      bannerFile: null,
    });
  };

  goToBannerList = () => {
    this.setState({ bannerView: "list", editingBanner: null });
    this.fetchBannerList();
  };

  handleBannerImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) {
      this.showError("Image size must be less than 3 MB.");
      e.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () =>
      this.setState({ bannerImagePreview: reader.result, bannerFile: file });
    reader.readAsDataURL(file);
  };

  removeBannerImage = () =>
    this.setState({ bannerImagePreview: null, bannerFile: null });

  saveBanner = async () => {
    const { bannerTitle, bannerFile, editingBanner } = this.state;

    // ✅ Banner image required for both Add and Edit
    if (!editingBanner && !bannerFile) {
      return this.showError("Banner image is required.");
    }
    if (editingBanner && !bannerFile && !editingBanner.imageUrl) {
      return this.showError("Banner image is required.");
    }

    this.setState({ bannerSaving: true });
    try {
      const formData = new FormData();
      formData.append("page_Name", bannerTitle);
      if (bannerFile) formData.append("files", bannerFile);
      if (editingBanner) formData.append("BannerID", editingBanner.Banner_id);

      const url = editingBanner
        ? `${API_URL}/api/banners/updateBanner`
        : `${API_URL}/api/banners/addBanner`;

      const res = await fetch(url, { method: "POST", body: formData });
      const json = await res.json();
      this.setState({ bannerSaving: false });

      if (json.status) {
        this.showSuccess(editingBanner ? "Banner updated!" : "Banner saved!");
        setTimeout(() => this.goToBannerList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch (err) {
      this.setState({ bannerSaving: false });
      this.showError("Cannot connect to API server.");
    }
  };
  deleteBanner = async (bannerId) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    try {
      const res = await fetch(`${API_URL}/api/banners/deleteBanner`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: bannerId }),
      });
      const json = await res.json();
      if (json.message == "Banner deleted successfully") {
        this.showSuccess("Banner deleted.");
        this.fetchBannerList();
      } else {
        this.showError(json.message || "Delete failed.");
      }
    } catch (err) {
      this.showError("Cannot connect to API server.");
    }
  };

  // ════════════════════════════════
  //  EVENT TYPES
  // Response: { data: [ [{event_type:"Corporate Events"}, ...], {...meta} ] }
  // So actual array is data[0]
  // ════════════════════════════════

  fetchEventTypes = async () => {
    this.setState({ eventTypesLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/event/geteventTypeList`, {
        method: "GET",
        headers: { "ngrok-skip-browser-warning": "true" },
      });

      const json = await res.json();
      console.log("welcome = ", json.data[0]);
      if (json.data[0]) {
        // data[0] is the array of { event_type: "..." }

        this.setState({ eventTypes: json.data[0], eventTypesLoading: false });
      } else {
        this.setState({ eventTypesLoading: false });
      }
    } catch (err) {
      this.setState({ eventTypesLoading: false });
    }
  };

  // ════════════════════════════════
  //  PORTFOLIO
  // ════════════════════════════════

  fetchPortfolioList = async () => {
    this.setState({ portfolioListLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/event/getAllEvents`, {
        method: "GET",
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      const json = await res.json();
      console.log("json = ", json.data);

      if (json) {
        this.setState({
          portfolioList: json.data,
          portfolioListLoading: false,
        });
      } else {
        this.setState({ portfolioListLoading: false });
        this.showError("Failed to load portfolio.");
      }
    } catch (err) {
      this.setState({ portfolioListLoading: false });
      this.showError("Cannot connect to API server.");
    }
  };

  openPortfolioForm = () => {
    this.setState({
      portfolioView: "form",
      editingPortfolio: null,
      portfolioForm: { name: "", eventTypeId: "", images: [], saving: false },
    });
  };

  openEditPortfolio = (item) => {
    this.setState({
      portfolioView: "form",
      editingPortfolio: item,
      portfolioForm: {
        name: item.event_name || item.event_name || "",
        eventTypeId: item.event_type || item.event_type || "",
        images: [],
        saving: false,
      },
    });
  };

  goToPortfolioList = () => {
    this.setState({ portfolioView: "list", editingPortfolio: null });
    this.fetchPortfolioList();
  };

  updatePortfolioForm = (field, value) => {
    this.setState((prev) => ({
      portfolioForm: { ...prev.portfolioForm, [field]: value },
    }));
  };

  handlePortfolioImages = (e) => {
    const files = Array.from(e.target.files);
    const oversized = files.find((f) => f.size > MAX_IMAGE_SIZE);
    if (oversized) {
      this.showError("Each image must be less than 3 MB.");
      e.target.value = "";
      return;
    }
    const newImages = [];
    let loaded = 0;
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newImages.push({ file, preview: reader.result });
        loaded++;
        if (loaded === files.length) {
          this.setState((prev) => ({
            portfolioForm: {
              ...prev.portfolioForm,
              images: [...prev.portfolioForm.images, ...newImages],
            },
          }));
        }
      };
      reader.readAsDataURL(file);
    });
  };

  removePortfolioImage = (index) => {
    this.setState((prev) => ({
      portfolioForm: {
        ...prev.portfolioForm,
        images: prev.portfolioForm.images.filter((_, i) => i !== index),
      },
    }));
  };

  savePortfolio = async () => {
    const { portfolioForm, editingPortfolio } = this.state;
    if (!portfolioForm.name.trim())
      return this.showError("Portfolio name is required.");
    if (!portfolioForm.eventTypeId)
      return this.showError("Please select an event type.");

    // ✅ Image validation — check length, not just truthy array
    // Add mode → must have at least 1 new image
    // Edit mode → must have existing OR new image
    console.log("editingPortfolio = ", editingPortfolio);
    const hasExistingImages =
      editingPortfolio &&
      editingPortfolio.imageArray &&
      editingPortfolio.imageArray.length > 0;
    if (!editingPortfolio && portfolioForm.images.length === 0) {
      console.log("Here2")
      return this.showError("Please add at least one image.");
    }
    if (
      editingPortfolio &&
      portfolioForm.images.length === 0 &&
      !hasExistingImages
    ) {
      console.log("Here3")
      return this.showError("Please add at least one image.");
    }

    this.setState((prev) => ({
      portfolioForm: { ...prev.portfolioForm, saving: true },
    }));
    try {
      const formData = new FormData();
      formData.append("event_name", portfolioForm.name);
      formData.append("event_type", portfolioForm.eventTypeId);
      formData.append("description", "asd");
      formData.append("sort_order", 0);
      portfolioForm.images.forEach((img) => formData.append("image", img.file));
      if (editingPortfolio)
        formData.append(
          "event_id",
          editingPortfolio.portfolio_id || editingPortfolio.portfolio_id,
        );
      const url = editingPortfolio
        ? `${API_URL}/api/event/updateEvent`
        : `${API_URL}/api/event/addEvent`;
      const res = await fetch(url, { method: "POST", body: formData });
      const json = await res.json();
      this.setState((prev) => ({
        portfolioForm: { ...prev.portfolioForm, saving: false },
      }));
      if (json.status) {
        this.showSuccess(
          `Portfolio ${editingPortfolio ? "updated" : "added"} successfully!`,
        );
        setTimeout(() => this.goToPortfolioList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch (err) {
      this.setState((prev) => ({
        portfolioForm: { ...prev.portfolioForm, saving: false },
      }));
      this.showError("Cannot connect to API server.");
    }
  };

  deletePortfolio = async (portfolioId) => {
    if (!window.confirm("Are you sure you want to delete this portfolio item?"))
      return;
    try {
      console.log("Deleting portfolio with ID:", portfolioId);
      const res = await fetch(`${API_URL}/api/event/deleteEvent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: portfolioId }),
      });
      const json = await res.json();
      if (json.message == "Event deleted successfully") {
        this.showSuccess("Portfolio item deleted.");
        this.fetchPortfolioList();
      } else {
        this.showError(json.message || "Delete failed.");
      }
    } catch (err) {
      this.showError("Cannot connect to API server.");
    }
  };

  deleteGalleryImage = async (imageId) => {
    if (!window.confirm("Delete this image permanently?")) return;
    try {
      const res = await fetch(`${API_URL}/api/gallery/deleteGalleryById`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: imageId }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Image deleted.");
        // Remove from editingPortfolio.imageArray locally — no refetch
        this.setState((prev) => ({
          editingPortfolio: {
            ...prev.editingPortfolio,
            imageArray: (prev.editingPortfolio.imageArray || []).filter(
              (img) => img.image_id !== imageId,
            ),
          },
        }));
      } else {
        this.showError(json.message || "Delete failed.");
      }
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════════════════
  //  RENDER
  // ════════════════════════════════
  render() {
    const {
      activeTab,
      bannerView,
      bannerList,
      bannerListLoading,
      bannerTitle,
      bannerImagePreview,
      bannerSaving,
      editingBanner,
      portfolioView,
      portfolioList,
      portfolioListLoading,
      portfolioForm,
      editingPortfolio,
      eventTypes,
      eventTypesLoading,
      successMessage,
      errorMessage,
    } = this.state;

    return (
      <div>
        <div className="page-header">
          <h2>Portfolio Page Manager</h2>
          <p>Manage banner and portfolio items.</p>
        </div>

        {successMessage && <div style={s.success}>{successMessage}</div>}
        {errorMessage && <div style={s.error}>{errorMessage}</div>}

        {/* Tabs */}
        <div className="rsp-tab-row" style={s.tabRow}>
          {["banner", "portfolio"].map((tab) => (
            <button
              key={tab}
              style={activeTab === tab ? s.tabActive : s.tab}
              onClick={() => this.setState({ activeTab: tab })}
            >
              {tab === "banner" ? "Banner" : "Portfolio"}
            </button>
          ))}
        </div>

        {/* ══ BANNER TAB ══ */}
        {activeTab === "banner" && (
          <div>
            {bannerView === "list" && (
              <div>
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>
                    {bannerListLoading
                      ? "Loading..."
                      : `${bannerList.length} banner${bannerList.length !== 1 ? "s" : ""} found`}
                  </span>
                  {bannerList.length === 0 && (
                    <button
                      className="rsp-btn-save"
                      style={s.btnSave}
                      onClick={() => this.openBannerForm()}
                    >
                      + Add Banner
                    </button>
                  )}
                </div>

                {bannerListLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading banners...</p>
                  </div>
                )}

                {!bannerListLoading && bannerList.length === 0 && (
                  <div style={s.emptyBox}>
                    <p style={{ ...s.emptyText, marginBottom: "12px" }}>
                      No banners found.
                    </p>
                    <button
                      className="rsp-btn-save"
                      style={s.btnSave}
                      onClick={this.openBannerForm}
                    >
                      + Add First Banner
                    </button>
                  </div>
                )}

                {!bannerListLoading &&
                  bannerList.map((banner, idx) => (
                    <div
                      key={banner.Banner_id || idx}
                      className="rsp-list-card"
                      style={s.listCard}
                    >
                      {banner.imageUrl ? (
                        <img
                          src={imgUrl(banner.imageUrl)}
                          alt="banner"
                          className="rsp-thumb-wide"
                          style={s.thumbImgWide}
                        />
                      ) : (
                        <div style={s.thumbPlaceholder}>No Image</div>
                      )}
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "4px",
                          }}
                        >
                          <strong style={s.itemTitle}>
                            {banner.Page_Name || "—"}
                          </strong>
                          <span style={s.idBadge}>ID: {banner.Banner_id}</span>
                        </div>
                        <p style={s.dateText}>
                          Added:{" "}
                          {new Date(banner.created_at).toLocaleDateString(
                            "en-IN",
                            { day: "2-digit", month: "short", year: "numeric" },
                          )}
                        </p>
                      </div>
                      <div className="rsp-action-btns" style={s.actionBtns}>
                        <button
                          className="rsp-btn-edit"
                          style={s.btnEdit}
                          onClick={() => this.openEditBanner(banner)}
                        >
                          Edit
                        </button>
                        <button
                          className="rsp-btn-delete"
                          style={s.btnDelete}
                          onClick={() => this.deleteBanner(banner.Banner_id)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
            )}

            {bannerView === "form" && (
              <div>
                <div className="rsp-form-top" style={s.formTopBar}>
                  <button
                    className="rsp-btn-back"
                    style={s.btnBack}
                    onClick={this.goToBannerList}
                  >
                    Back to List
                  </button>
                  <h3 style={s.formTitle}>
                    {editingBanner
                      ? `Edit Banner — ID ${editingBanner.Banner_id}`
                      : "Add New Banner"}
                  </h3>
                </div>
                <div className="card">
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Banner Image *</label>
                    {editingBanner &&
                      !bannerImagePreview &&
                      editingBanner.imageUrl && (
                        <div style={{ marginBottom: "10px" }}>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#888",
                              marginBottom: "6px",
                            }}
                          >
                            Current image:
                          </p>
                          <img
                            src={imgUrl(editingBanner.imageUrl)}
                            alt="current"
                            style={{
                              width: "200px",
                              height: "70px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              border: "1px solid #e8e8e8",
                            }}
                          />
                        </div>
                      )}
                    {bannerImagePreview ? (
                      <div className="rsp-preview-box" style={s.previewBox}>
                        <img
                          src={bannerImagePreview}
                          alt="Preview"
                          style={s.previewImg}
                        />
                        <div style={s.overlay}>
                          <button
                            className="rsp-btn-delete"
                            style={s.btnDelete}
                            onClick={this.removeBannerImage}
                          >
                            Remove
                          </button>
                          <label className="rsp-btn-dark" style={s.btnDark}>
                            Change
                            <input
                              type="file"
                              accept="image/*"
                              onChange={this.handleBannerImage}
                              style={{ display: "none" }}
                            />
                          </label>
                        </div>
                      </div>
                    ) : (
                      <label className="rsp-upload-box" style={s.uploadBox}>
                        <p style={s.uploadText}>
                          {editingBanner
                            ? "Click to replace image"
                            : "Click to choose banner image"}
                        </p>
                        <p style={s.uploadHint}>
                          JPG, PNG, WEBP — Max 5MB — 1920x600px recommended
                        </p>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={this.handleBannerImage}
                          style={{ display: "none" }}
                        />
                      </label>
                    )}
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Banner Title</label>
                    <input
                      disabled
                      type="text"
                      value={bannerTitle}
                      onChange={(e) =>
                        this.setState({ bannerTitle: e.target.value })
                      }
                      placeholder="e.g. Portfolio"
                      className="rsp-input"
                      style={s.input}
                    />
                  </div>
                  <div className="rsp-form-actions" style={s.formActions}>
                    <button
                      className="rsp-btn-back"
                      style={s.btnBack}
                      onClick={this.goToBannerList}
                    >
                      Cancel
                    </button>
                    <button
                      className="rsp-btn-save"
                      style={s.btnSave}
                      onClick={this.saveBanner}
                      disabled={bannerSaving}
                    >
                      {bannerSaving
                        ? "Saving..."
                        : editingBanner
                          ? "Update Banner"
                          : "Save Banner"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ══ PORTFOLIO TAB ══ */}
        {activeTab === "portfolio" && (
          <div>
            {portfolioView === "list" && (
              <div>
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>
                    {portfolioListLoading
                      ? "Loading..."
                      : `${portfolioList.length} item${portfolioList.length !== 1 ? "s" : ""} found`}
                  </span>
                  <button
                    className="rsp-btn-save"
                    style={s.btnSave}
                    onClick={this.openPortfolioForm}
                  >
                    + Add Portfolio
                  </button>
                </div>

                {portfolioListLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading portfolio...</p>
                  </div>
                )}

                {!portfolioListLoading && portfolioList.length === 0 && (
                  <div style={s.emptyBox}>
                    <p style={{ ...s.emptyText, marginBottom: "12px" }}>
                      No portfolio items found.
                    </p>
                    <button
                      className="rsp-btn-save"
                      style={s.btnSave}
                      onClick={this.openPortfolioForm}
                    >
                      + Add First Item
                    </button>
                  </div>
                )}
               

                {!portfolioListLoading &&
                  portfolioList.map(
                    (item, idx) =>
                      console.log("item = ", item.imageArray[0]) || (
                        <div
                          key={item.portfolio_id || idx}
                          className="rsp-list-card"
                          style={s.listCard}
                        >
                          {item.imageArray[0] ||
                          (item.imageArray[0] && item.imageArray[0]) ? (
                            <img
                              src={imgUrl(item.imageArray[0].image_url)}
                              alt={item.event_name}
                              style={s.portfolioThumb}
                            />
                          ) : (
                            <div style={s.thumbPlaceholder}>No Image</div>
                          )}
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                marginBottom: "6px",
                                flexWrap: "wrap",
                              }}
                            >
                              <strong style={s.itemTitle}>
                                {item.event_name || item.event_name || "—"}
                              </strong>
                              <span style={s.idBadge}>ID: {item.event_id}</span>
                              {(item.event_type || item.event_type) && (
                                <span style={s.typeBadge}>
                                  {item.event_type || item.event_type}
                                </span>
                              )}
                            </div>
                            <p style={s.dateText}>
                              Added:{" "}
                              {new Date(item.created_at).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )}
                            </p>
                          </div>
                          <div className="rsp-action-btns" style={s.actionBtns}>
                            <button
                              className="rsp-btn-edit"
                              style={s.btnEdit}
                              onClick={() => this.openEditPortfolio(item)}
                            >
                              Edit
                            </button>
                            <button
                              className="rsp-btn-delete"
                              style={s.btnDelete}
                              onClick={() =>
                                this.deletePortfolio(item.portfolio_id)
                              }
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      ),
                  )}
              </div>
            )}

            {portfolioView === "form" && (
              <div>
                <div className="rsp-form-top" style={s.formTopBar}>
                  <button
                    className="rsp-btn-back"
                    style={s.btnBack}
                    onClick={this.goToPortfolioList}
                  >
                    Back to List
                  </button>
                  <h3 style={s.formTitle}>
                    {editingPortfolio
                      ? `Edit — ${editingPortfolio.event_name || editingPortfolio.event_name}`
                      : "Add New Portfolio Item"}
                  </h3>
                </div>

                <div className="card">
                  <div className="rsp-two-col" style={s.twoCol}>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Portfolio Name *</label>
                      <input
                        className="rsp-input"
                        style={s.input}
                        type="text"
                        value={portfolioForm.name}
                        placeholder="e.g. Celebrity Football Cup 2024"
                        onChange={(e) =>
                          this.updatePortfolioForm("name", e.target.value)
                        }
                      />
                    </div>

                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Event Type *</label>
                      <select
                        className="rsp-select"
                        style={s.select}
                        value={portfolioForm.eventTypeId}
                        onChange={(e) =>
                          this.updatePortfolioForm(
                            "eventTypeId",
                            e.target.value,
                          )
                        }
                      >
                        {/* ✅ Correct field: event_type from API response */}
                        <option value="">
                          {eventTypesLoading
                            ? "Loading..."
                            : "Select Event Type"}
                        </option>
                        {eventTypes.map((type, i) => (
                          <option key={i} value={type.event_type}>
                            {type.event_type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>
                      Portfolio Images *
                      <span
                        style={{
                          color: "#aaa",
                          fontWeight: "400",
                          marginLeft: "6px",
                        }}
                      >
                        (select multiple)
                      </span>
                    </label>

                    {/* Existing images when editing */}
                    {editingPortfolio &&
                      (() => {
                        const validImages = (
                          editingPortfolio.imageArray || []
                        ).filter((img) => img.image_id && img.image_url);

                        if (validImages.length === 0) {
                          return (
                            <div style={{ marginBottom: "10px" }}>
                              <p style={s.hint}>No images uploaded yet.</p>
                            </div>
                          );
                        }

                        return (
                          <div style={{ marginBottom: "10px" }}>
                            <p style={s.hint}>
                              Current gallery ({validImages.length} image(s)):
                            </p>
                            <div className="rsp-image-grid" style={s.imageGrid}>
                              {validImages.map((img) => (
                                <div
                                  key={img.image_id}
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    src={imgUrl(img.image_url)}
                                    alt={`gallery-${img.image_id}`}
                                    style={s.imgThumb}
                                  />
                                  <button
                                    type="button"
                                    title="Delete image permanently"
                                    style={s.deleteImgBtn}
                                    onClick={() =>
                                      this.deleteGalleryImage(img.image_id)
                                    }
                                  >
                                    ×
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })()}

              

                    {/* New images preview */}
                    {portfolioForm.images.length > 0 && (
                      <div style={{ marginBottom: "12px" }}>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#888",
                            marginBottom: "8px",
                          }}
                        >
                          {editingPortfolio
                            ? "New images to add:"
                            : "Selected images:"}
                          <span style={{ color: "#e8a020", marginLeft: "6px" }}>
                            {portfolioForm.images.length} selected
                          </span>
                        </p>
                        <div className="rsp-image-grid" style={s.imageGrid}>
                          {portfolioForm.images.map((img, i) => (
                            <div key={i} style={{ position: "relative" }}>
                              <img
                                src={img.preview}
                                alt={`new-${i}`}
                                style={s.imgThumb}
                              />
                              <button
                                style={s.removeImgBtn}
                                onClick={() => this.removePortfolioImage(i)}
                              >
                                X
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <label className="rsp-upload-box" style={s.uploadBox}>
                      <p style={s.uploadText}>
                        {portfolioForm.images.length > 0
                          ? "Click to add more images"
                          : "Click to select images"}
                      </p>
                      <p style={s.uploadHint}>
                        JPG, PNG — Use Ctrl+Click or Shift+Click to select
                        multiple
                      </p>
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={this.handlePortfolioImages}
                        style={{ display: "none" }}
                      />
                    </label>
                  </div>

                  <div className="rsp-form-actions" style={s.formActions}>
                    <button
                      className="rsp-btn-back"
                      style={s.btnBack}
                      onClick={this.goToPortfolioList}
                    >
                      Cancel
                    </button>
                    <button
                      className="rsp-btn-save"
                      style={s.btnSave}
                      onClick={this.savePortfolio}
                      disabled={portfolioForm.saving}
                    >
                      {portfolioForm.saving
                        ? "Saving..."
                        : editingPortfolio
                          ? `Update ${portfolioForm.name || "Portfolio"}`
                          : `Save ${portfolioForm.name || "Portfolio"}`}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const s = {
  success: {
    background: "#e8f5e9",
    color: "#2e7d32",
    border: "1px solid #c8e6c9",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "16px",
    fontSize: "14px",
  },
  error: {
    background: "#ffebee",
    color: "#c62828",
    border: "1px solid #ffcdd2",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "16px",
    fontSize: "14px",
  },
  tabRow: {
    display: "flex",
    gap: "10px",
    borderBottom: "2px solid #e8e8e8",
    marginBottom: "20px",
  },
  tab: {
    padding: "10px 20px",
    background: "none",
    border: "none",
    borderBottom: "3px solid transparent",
    fontSize: "14px",
    color: "#888",
    cursor: "pointer",
    marginBottom: "-2px",
    fontWeight: "500",
  },
  tabActive: {
    padding: "10px 20px",
    background: "none",
    border: "none",
    borderBottom: "3px solid #e8a020",
    fontSize: "14px",
    color: "#e8a020",
    cursor: "pointer",
    marginBottom: "-2px",
    fontWeight: "600",
  },
  listTopBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  countText: { fontSize: "14px", color: "#888" },
  listCard: {
    background: "white",
    borderRadius: "10px",
    padding: "18px 20px",
    border: "1px solid #e8e8e8",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  itemTitle: { fontSize: "15px", color: "#1a1a2e" },
  idBadge: {
    background: "#f0f2f5",
    color: "#888",
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    padding: "2px 8px",
    fontSize: "11px",
  },
  typeBadge: {
    background: "#e8f4fd",
    color: "#1565c0",
    border: "1px solid #bbdefb",
    borderRadius: "10px",
    padding: "2px 10px",
    fontSize: "11px",
    fontWeight: "600",
  },
  dateText: { fontSize: "11px", color: "#bbb", marginTop: "4px" },
  emptyBox: {
    background: "white",
    borderRadius: "10px",
    padding: "48px 20px",
    border: "1px solid #e8e8e8",
    textAlign: "center",
  },
  emptyText: { color: "#aaa", fontSize: "14px" },
  thumbImgWide: {
    width: "120px",
    height: "70px",
    objectFit: "cover",
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
    flexShrink: 0,
  },
  portfolioThumb: {
    width: "100px",
    height: "70px",
    objectFit: "cover",
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
    flexShrink: 0,
  },
  thumbPlaceholder: {
    width: "100px",
    height: "70px",
    background: "#f0f2f5",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    color: "#aaa",
    flexShrink: 0,
  },
  actionBtns: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flexShrink: 0,
  },
  btnEdit: {
    background: "#e3f2fd",
    color: "#1565c0",
    border: "1px solid #bbdefb",
    padding: "6px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
    minWidth: "64px",
  },
  btnDelete: {
    background: "#ffebee",
    color: "#c62828",
    border: "1px solid #ffcdd2",
    padding: "6px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
    minWidth: "64px",
  },
  formTopBar: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "16px",
  },
  formTitle: { fontSize: "16px", color: "#1a1a2e", margin: 0 },
  formActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    borderTop: "1px solid #f0f0f0",
    paddingTop: "16px",
  },
  formGroup: { marginBottom: "18px" },
  label: {
    display: "block",
    fontSize: "13px",
    color: "#555",
    fontWeight: "600",
    marginBottom: "6px",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
    fontFamily: "Arial, sans-serif",
  },
  select: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
    fontFamily: "Arial, sans-serif",
    background: "white",
    cursor: "pointer",
  },
  uploadBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #ddd",
    borderRadius: "10px",
    padding: "28px 20px",
    cursor: "pointer",
    background: "#fafafa",
    textAlign: "center",
  },
  uploadText: { fontSize: "14px", color: "#555", marginBottom: "4px" },
  uploadHint: { fontSize: "11px", color: "#aaa" },
  previewBox: {
    position: "relative",
    borderRadius: "10px",
    overflow: "hidden",
    border: "1px solid #e8e8e8",
  },
  previewImg: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    display: "block",
  },
  overlay: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    display: "flex",
    gap: "8px",
  },
  imageGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: "8px",
    marginBottom: "10px",
  },
  imgThumb: {
    width: "100%",
    aspectRatio: "1",
    objectFit: "cover",
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
  },
  removeImgBtn: {
    position: "absolute",
    top: "2px",
    right: "2px",
    width: "18px",
    height: "18px",
    background: "#e53935",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    fontSize: "10px",
    cursor: "pointer",
    fontWeight: "700",
  },
  btnRed: {
    background: "#e53935",
    color: "#fff",
    border: "none",
    padding: "7px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
  },
  btnDark: {
    background: "#1a1a2e",
    color: "#fff",
    border: "none",
    padding: "7px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
  },
  btnSave: {
    background: "#e8a020",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  btnBack: {
    background: "#f0f2f5",
    color: "#333",
    border: "1px solid #ddd",
    padding: "9px 16px",
    borderRadius: "8px",
    fontSize: "13px",
    cursor: "pointer",
    fontWeight: "500",
  },
  twoCol: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" },
  deleteImgBtn: {
    position: "absolute",
    top: "4px",
    right: "4px",
    width: "24px",
    height: "24px",
    background: "#e53935",
    color: "#fff",
    border: "2px solid #fff",
    borderRadius: "50%",
    fontSize: "16px",
    cursor: "pointer",
    fontWeight: "700",
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.25)",
    padding: 0,
  },
};

export default Portfolio;
